import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UserActions from 'flux/actions/UserActions';
import UIRegions from 'shared/constants/UIRegions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import { displayView as DisplayViewOnboarding } from 'shared/constants/Onboarding';
import { Row, Col, Button } from 'bootstrap';
import s3 from 'shared/constants/s3';

export default React.createClass({
  displayName: 'DisplayViewModal',

  mixins: [Reflux.connect(UserSessionStore, 'user')],

  getInitialState() {
    return {};
  },

  render() {
    return (
      <Modal
        name={UIRegions.DisplayViewModal}
        className="display-view-modal"
        closeButton={false}
        overrideHide
      >
        <Row>
          <Col md={24}>
            <div className="image-container">
              <img src={s3.displayViewModalImage} alt="display view" />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="display-view-modal-title">
              Welcome to our new Display View!
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="display-view-modal-description">
              A Shoflo view for backstage & control rooms displays. Take your
              browser into full screen mode and automatically follow the Show
              Caller.
            </div>
            <div className="display-view-modal-trial">
              Enjoy a free trial of this premium feature!
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Button
              className="display-view-modal-btn"
              onClick={this._handleOnHide}
            >
              Get Started
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="display-view-modal-learn-link">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://shoflo.tv/display-view"
              >
                Learn more about Display View
              </a>
            </div>
          </Col>
        </Row>
      </Modal>
    );
  },

  _handleOnHide() {
    ModalActions.hide(UIRegions.DisplayViewModal);
    UserActions.updateOnboarding(
      this.state.user.get('_id'),
      DisplayViewOnboarding.displayViewModal,
      true,
    );
  },
});
